import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  Paper,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { State } from "state";
import {
  fetchRequestDetailByEmail,
  hideSearchEmailModal,
  showRequestDetailsModal,
} from "state/request";
import { buttonStyles } from "styles/buttonStyles";

const styles = (theme: any) => ({
  ...(buttonStyles as any),
  modalPaper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "90%", // xs default
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    borderRadius: 12,
    outline: "none",
    backgroundColor: "#fff",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",

    [theme.breakpoints.up("sm")]: {
      width: "80%",
    },
    [theme.breakpoints.up("md")]: {
      width: "40%",
    },
  },
});

type Props = PropsFromRedux & { classes: any };

type LocalState = {
  email: string;
  requestId: string;
};

class TrackRequestModal extends React.Component<Props, LocalState> {
  private initialState: LocalState = {
    email: "",
    requestId: "",
  };

  state: LocalState = this.initialState;
  handleClose = () => {
    this.setState(this.initialState);
    this.props.hideSearchEmailModal();
  };
  handleInputChange =
    (field: string) => (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
      this.setState({ [field]: e.target.value } as any);
    };

  handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await this.props.fetchRequestDetailByEmail({
        email: this.state.email,
        requestId: this.state.requestId,
      });
      this.props.hideSearchEmailModal();
      this.props.showRequestDetailsModal();
    } catch (error) {
      console.error("Error creating anonymous request:", error);
    }
  };

  render() {
    const {
      showModal,
      classes,
      requestDetailByEmail: { loading },
    } = this.props;
    const isValid = !loading;

    const submitStyle: React.CSSProperties = {
      backgroundColor: isValid ? "#D79A00" : "#EDEDED",
      color: isValid ? "#000" : "#9E9E9E",
      borderRadius: 6,
      textTransform: "none",
      padding: "8px 18px",
      cursor: isValid ? "pointer" : "not-allowed",
      boxShadow: isValid ? undefined : "none",
    };

    return (
      <Modal
        open={showModal}
        onClose={this.handleClose}
        closeAfterTransition
        disableBackdropClick
        BackdropProps={{ timeout: 300 }}
      >
        <Paper className={classes.modalPaper}>
          <div
            style={{
              borderBottom: `1px solid #e9eef2`,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ padding: "16px 32px" }}>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 700, textTransform: "none", color: "#333333" }}
              >
                Track Your Request
              </Typography>
              <Typography variant="body2" style={{ color: "#6b7174" }}>
                Enter your email address to view the status of your requests.
              </Typography>
            </div>
            <div style={{ padding: 12 }}>
              <IconButton onClick={this.handleClose} aria-label="close" disabled={loading}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <form onSubmit={this.handleSubmit}>
            <div style={{ padding: "16px 32px", overflowY: "auto" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant="body2" style={{ marginBottom: 8 }}>
                    Email Address <span style={{ color: "#d32f2f" }}>*</span>
                  </Typography>
                  <TextField
                    variant="outlined"
                    type={"email"}
                    placeholder="Please enter your email"
                    fullWidth
                    size="small"
                    required
                    value={this.state.email}
                    onChange={this.handleInputChange("email")}
                    InputProps={{ style: { borderRadius: 16 } }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="body2" style={{ marginBottom: 8 }}>
                    Request ID: <span style={{ color: "#d32f2f" }}>*</span>
                  </Typography>
                  <TextField
                    variant="outlined"
                    placeholder="Please enter your request ID REQ-123456"
                    fullWidth
                    size="small"
                    required
                    value={this.state.requestId}
                    onChange={this.handleInputChange("requestId")}
                    InputProps={{ style: { borderRadius: 16 } }}
                  />
                </Grid>
              </Grid>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px 32px" }}>
              <Button
                variant="outlined"
                onClick={this.handleClose}
                style={{
                  borderRadius: 6,
                  textTransform: "none",
                  padding: "8px 18px",
                  marginRight: 12,
                }}
                disabled={loading}
                className={classes.cancelBtn}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                style={{ ...submitStyle, cursor: "inherit" }}
                className={classes.submitBtn}
                disabled={!isValid}
                type="submit"
              >
                {loading && (
                  <CircularProgress size={16} style={{ color: "#000", marginRight: 8 }} />
                )}
                View Status
              </Button>
            </div>
          </form>
        </Paper>
      </Modal>
    );
  }
}

const connecter = connect(
  (state: State) => ({
    showModal: state.requests.showSearchEmailModal,
    requestDetailByEmail: state.requests.anonymousRequestData,
  }),
  { hideSearchEmailModal, showRequestDetailsModal, fetchRequestDetailByEmail }
);

type PropsFromRedux = ConnectedProps<typeof connecter>;

export default connecter(withStyles(styles)(TrackRequestModal));
